/** The languages the apps support. */
export type Language = 'en' | 'no';

/**
 * Narrow an arbitrary language string to the canonical set the apps support.
 *
 * Returns `'en'` for English, and `'no'` for anything else (the default).
 */
export function normalizeLanguage(language: string): Language {
  return language === 'en' ? 'en' : 'no';
}
